'use client';

import { useEffect } from 'react';
import { ErrorOld } from 'ui/errors';
import { Box } from '@mui/material';
import logger from 'logger';

export const metadata = {
  title: '500 | Lingo',
  description: 'Internal Server Error',
};

// TODO: Refactor all error cases with 'throw New Error()' to end up on this page
// which will help create better error handling
export default function ErrorPage({ error }) {
  useEffect(() => {
    logger.error(error);
  }, [error]);

  return (
    <Box gridColumn='1/-1'>
      <ErrorOld code={500} title='Internal Server Error' />
    </Box>
  );
}
